import { call, put, takeLatest } from 'redux-saga/effects';
import { fetchClient } from '../utilities/fetchClient';
import ActionTypes from '../actions/actionTypes';
import {  getBillingSuccess, getBillingFailure } from '../actions/billingActions';
//import { isMobile } from '../utilities/usersDevice';
import Env from '../Env';
/*
Yet to be implemented, code will likely be moved to relevant file upon implementation, accountsSaga.js?
*/
function* getBilling(action) {
  try {
    const header = {
      'Ocp-Apim-Subscription-Key': Env.getApimKey(),
    };
    const response = yield call(fetchClient, {
      url: `accounts-api/v1/accounts/contract/${action.contractIdentifier}/payment/summary`,
      method: 'GET',
      headers: header,
      apiServer: Env.getApimBaseUrl()
    });
    yield put(getBillingSuccess(response));
  } catch (e) {
    yield put(getBillingFailure());
  }
}

export default function* billingSaga() {
  yield takeLatest(ActionTypes.BILLING.REQUEST, getBilling);
}

